import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sv-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "sv-page-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "sv-page-header__eyebrow" }, "Indicadores do processamento"),
    /*#__PURE__*/_createElementVNode("h1", null, "Performance"),
    /*#__PURE__*/_createElementVNode("p", null, "Visualize o desempenho diário dos uploads e a distribuição das gravações por horário.")
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummaryDay = _resolveComponent("SummaryDay")!
  const _component_UploadSuccessCard = _resolveComponent("UploadSuccessCard")!
  const _component_UploadErrorCard = _resolveComponent("UploadErrorCard")!
  const _component_UploadTotalSize = _resolveComponent("UploadTotalSize")!
  const _component_UploadTotalDuration = _resolveComponent("UploadTotalDuration")!
  const _component_UploadTotalsHour = _resolveComponent("UploadTotalsHour")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SummaryDay)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_UploadSuccessCard),
        _createVNode(_component_UploadErrorCard)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_UploadTotalSize),
        _createVNode(_component_UploadTotalDuration)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_UploadTotalsHour)
      ])
    ])
  ]))
}